import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const PassionateCard = (props: any) => {
  const [des, setDes] = useState([]);

  useEffect(() => {
    if (props?.coreValuesData) {
      const finalArray = props?.coreValuesData.map((item: any) => ({
        ...item,
        seeMore: false,
      }));
      setDes(finalArray);
    }
  }, [props?.coreValuesData]);

  const handleSeeMore = (id: any) => {
    const data = des.map((item) =>
      item.id === id ? { ...item, seeMore: true } : { ...item, seeMore: false }
    );
    setDes(data);
  };
  return (
    <section className="passionate-section">
      <div className="container">
        <h2 className="section-heading">{props?.coreValuesTitle}</h2>
        <div className="solution-cards">
          <div className="row justify-content-center g-3">
            {des &&
              des?.length &&
              des?.map((item: any, index: any) => {
                return (
                  <>
                    <div
                      key={index}
                      className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                    >
                      <div className="card sv-solution-card">
                        <div className="card-body p-0">
                          <div className="row g-0 h-100">
                            <div className="col-xl-8 col-lg-8 col-md-9 col-8">
                              <div className="card-body-padding">
                                <h5 className="card-title">{item?.Title}</h5>
                                <div
                                  className="card-text"
                                  {...(item.seeMore && {
                                    style: { display: 'block' },
                                  })}
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                      item?.Description
                                    ),
                                  }}
                                ></div>
                                <div
                                  className="card-link link"
                                  {...(item.seeMore && {
                                    style: { display: 'none' },
                                  })}
                                  onClick={() => handleSeeMore(item.id)}
                                >
                                  <FormattedMessage id="buttons.seeMore" />{' '}
                                  {'>>'}
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-3 col-4">
                              <Image
                                sizes="(max-width: 375px) 95px, (max-width: 576px) 175px, (max-width: 768px) 110px, (max-width: 992px) 150px, (max-width: 1280px) 175px"
                                className="img-fluid card-img"
                                src={
                                  item?.Thumbnail?.data?.attributes?.url || ''
                                }
                                width="175"
                                height="142"
                                alt={
                                  item?.Thumbnail?.data?.attributes
                                    ?.alternativeText ||
                                  item?.Thumbnail?.data?.attributes?.name
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default PassionateCard;
